import React, { HTMLAttributes } from 'react'

import { Input } from '@/components/ui/input'
import { useCompanyCompassLink } from '@/hooks/useCompanyCompassLink'
import { cn } from '@/lib/utils'

type Props = Omit<HTMLAttributes<HTMLInputElement>, 'value' | 'readonly'>

const CompanyCompassLinkInput: React.FC<Props> = ({ className, ...props }) => {
  const link = useCompanyCompassLink()

  return (
    <Input
      className={cn('text-dim min-w-25 grow', className)}
      value={link}
      readOnly
      {...props}
    />
  )
}

export default CompanyCompassLinkInput
